/**
 * Cart line unit price in cents. Use nullish coalescing so 0 (free / promo) is valid.
 */
export function getLineUnitPriceCents(item) {
  if (!item) return 0;
  const raw = item.unitPrice ?? item.price_cents ?? item.price;
  if (raw === undefined || raw === null) return 0;
  const n = Number(raw);
  return Number.isFinite(n) ? n : 0;
}
